import {
  Component, Output, EventEmitter,
  Input, ChangeDetectionStrategy, ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from '@shared/auth/auth.service';
import { SharedService } from 'app/services/core/shared.service';

@Component({
  selector: 'app-navbar',
  host: {
    class: 'matero-header',
  },
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  public environment = environment;
  @Input() isMobile = false;
  @Input() showToggle = true;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleChatbotNotice = new EventEmitter<void>();

  public userName: string = 'Loading...'; 

  constructor(public sharedService: SharedService, public authService: AuthService,
    private cdRef: ChangeDetectorRef
  ) {
    this.authService.currentUserEvent.subscribe(() => {
      let user = this.authService.getUser();
      if (!user && user.fullName != this.userName) {

      }
      this.userName = user != null ? user.fullName : null;
      this.cdRef.detectChanges();
      // console.log('Navbar userName updated:', this.userName);
    });
  }

  toggleTheme() {
    this.sharedService.darkMode = !this.sharedService.darkMode;
    this.sharedService.userTheme = this.sharedService.darkMode ? "dark" : "light";
    this.sharedService.toggleTheme();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

}
